"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesListRequestSortingItem = void 0;
exports.ServicesListRequestSortingItem = {
    DirectoryAsc: "directory:asc",
    DirectoryDesc: "directory:desc",
    NameAsc: "name:asc",
    NameDesc: "name:desc",
    IdAsc: "id:asc",
    IdDesc: "id:desc",
    CreatedTimeAsc: "createdTime:asc",
    CreatedTimeDesc: "createdTime:desc",
    MimeTypeAsc: "mimeType:asc",
    MimeTypeDesc: "mimeType:desc",
    FileExtensionAsc: "fileExtension:asc",
    FileExtensionDesc: "fileExtension:desc",
    SizeBytesAsc: "sizeBytes:asc",
    SizeBytesDesc: "sizeBytes:desc",
    ImageUrlAsc: "imageUrl:asc",
    ImageUrlDesc: "imageUrl:desc",
};
